import { useCallback } from "react";

import { useDialog } from "../../../common/components/dialog/useDialog";
import { useStreamProcesses } from "../../../common/hooks/useStreamProcesses";
import LiveButton from "./LiveButton";
import LiveViewDialog from "./LiveViewDialog";

interface LiveViewButtonContainerProps {
  cameraId: string;
  nodeId: string;
}

const LiveViewButtonContainer = ({
  cameraId,
  nodeId,
}: LiveViewButtonContainerProps) => {
  const { open, handleDialogClose, handleDialogOpen } = useDialog();

  const { startStreaming, stopStreaming } = useStreamProcesses();

  const memoizedOnCloseCallback = useCallback(() => {
    handleDialogClose();

    stopStreaming({
      deviceId: cameraId,
      nodeId: nodeId,
    });
  }, [handleDialogClose]);

  const memoizedDialogOpenCallback = useCallback(() => {
    handleDialogOpen();

    // on hardhat page, cameraId has prefix hardhat-, so we need to remove it. If not there we ignore
    const splits = cameraId.split("hardhat-");
    const deviceId = splits[splits.length - 1];

    startStreaming({
      deviceId,
      nodeId,
    });
  }, [handleDialogOpen]);

  return (
    <>
      <LiveButton
        onClick={memoizedDialogOpenCallback}
        disabled={!cameraId && !nodeId}
      />
      {open && <LiveViewDialog onClose={memoizedOnCloseCallback} />}
    </>
  );
};

export default LiveViewButtonContainer;
